// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AHuo","title":"Header_title__3zJi-","side":"Header_side__2Kz34"};